<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :title="$t('myProfile.savingPersonalData')"
      :routeBackName="routeBackName"
    />
    <span class="msg" v-if="getSubUserData.subUserId != 0"
      >הינך מחובר למשתמש {{ getSubUserData.subUserName || "" }}</span
    >
    <ul class="list-main-setting list-menu">
      <li class="row-in-setting item" v-if="getSubUserData.subUserId == 0">
        <RowItem
          @click="loginSubUser"
          :title="$t('login.login')"
          :HasIconItem="false"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
      </li>
      <li v-else class="row-in-setting item">
        <RowItem
          v-disable
          @click="logoutSubUser"
          :title="$t('login.logout')"
          :HasIconItem="false"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
      </li>
      <li class="item">
        <RowItem
          v-disable
          @click="goToCreateSubUser"
          :title="$t('myProfile.createSubUser')"
          :HasIconItem="false"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          iconItem="8"
          :HasIconCheckbox="false"
          type="checkbox"
        />
        <router-view />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DesktopMix from "@/mixing/mixDesktop";
import menuService from "@/services/menu";
export default {
  data() {
    return {
      routeBackName: "myProfile",
      commentsIcon: "fa fa-comment-o",
      keysIcon: "fa fa-key",
      markersIcon: "fa fa-paint-brush",
      linksIcon: "fa fa-link",
    };
  },
  mixins: [DesktopMix],
  computed: {
    ...mapGetters("user", ["getSubUserData"]),
  },
  methods: {
    ...mapActions("user", ["setSubUser"]),
    ...mapActions("personalAdditionsTabs", ["clearAllPersonalAdditions"]),
    loginSubUser() {
      menuService.openLoginSubUser();
      this.clearAllPersonalAdditions();
    },
    logoutSubUser() {
      this.saveCurrentDesktop(true);
      this.setSubUser({ subUserId: 0, subUserName: "" });
      this.clearAllPersonalAdditions();
      this.$store.dispatch("books/resetActiveStore");
    },
    goToCreateSubUser() {
      menuService.openCreateSubUser();
    },
  },
};
</script>

<style lang="scss" scoped>
.msg {
  text-align: center;
  margin-top: 10px;
  font-weight: 600;
  font-size: 14px;
  color: var(--custom-color1);
}
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 3;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-main-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
}
</style>
